import { DefaultTheme } from 'styled-components'

import { colors } from './colors'
import { typography } from './typography'

export const csasTheme: DefaultTheme = {
  colors,
  typography
}
